const WORD_CHAR_RE = /[\p{L}\p{N}_]/u

function isWordChar(char: string | undefined): boolean {
  return !!char && WORD_CHAR_RE.test(char)
}

/**
 * Expands a Range so both endpoints sit on word boundaries (within the
 * start/end text nodes only). Callers should write the result back to
 * `window.getSelection()` so the highlight visibly grows — never capture
 * more than the user can see selected.
 */
export function expandRangeToWordBoundaries(range: Range): Range {
  const expanded = range.cloneRange()

  if (expanded.startContainer instanceof Text) {
    const data = expanded.startContainer.data
    let offset = expanded.startOffset

    while (offset > 0 && isWordChar(data[offset - 1])) {
      offset--
    }

    if (offset !== expanded.startOffset) {
      expanded.setStart(expanded.startContainer, offset)
    }
  }

  if (expanded.endContainer instanceof Text) {
    const data = expanded.endContainer.data
    let offset = expanded.endOffset

    while (offset < data.length && isWordChar(data[offset])) {
      offset++
    }

    if (offset !== expanded.endOffset) {
      expanded.setEnd(expanded.endContainer, offset)
    }
  }

  return expanded
}
